import { ParsedUrlQuery } from "querystring";
import { BroadcastReportingInputBase } from "~graphql/sdk";
import * as Sentry from "@sentry/nextjs";

export type BroadcastReportingTrackingRaw = { rawData: string };

export type BroadcastReportingTracking = BroadcastReportingInputBase &
  BroadcastReportingTrackingRaw;

export const broadcastParamsFromReportingString = (
  reportingString: string
): BroadcastReportingTracking => {
  try {
    return {
      ...(JSON.parse(reportingString) as BroadcastReportingInputBase),
      rawData: reportingString,
    };
  } catch (e) {
    Sentry.captureException(
      new Error("Error de-serialising broadcast reporting params"),
      {
        tags: {
          action: "broadcastParamsFromReportingId",
        },
        extra: {
          args: reportingString,
          error: e,
        },
      }
    );
  }
};

export const getBroadcastParamsFromQuery = (
  query: ParsedUrlQuery
): BroadcastReportingTracking | null => {
  const reportingString = (query?.["campaign-id"] ?? "") as string;
  return reportingString
    ? broadcastParamsFromReportingString(reportingString)
    : null;
};
